var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#60666C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.333 8.167H1.667M13.704.833V4.5M6.296.833V4.5m-.185 14.667h7.778c1.555 0 2.333 0 2.928-.3a2.76 2.76 0 0 0 1.213-1.202c.303-.588.303-1.358.303-2.898v-7.7c0-1.54 0-2.31-.303-2.899a2.76 2.76 0 0 0-1.213-1.202c-.595-.3-1.373-.3-2.928-.3H6.11c-1.556 0-2.334 0-2.928.3A2.76 2.76 0 0 0 1.97 4.168c-.302.588-.302 1.359-.302 2.899v7.7c0 1.54 0 2.31.302 2.898.267.518.692.938 1.214 1.202.594.3 1.372.3 2.928.3"
  })));
};
export default SvgCalendar;